import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Tag, Select, Space, Row, Col } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { UserOutlined, PhoneOutlined, LinkOutlined } from "@ant-design/icons";

import { IContact, IShipco, IShipcoGroup, IVessel } from "interfaces";
import React from "react";
import { FormSection, FormFieldGrid } from "components/form";

export const ContactEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    query,
    formLoading: isLoading,
  } = useForm<IContact>();

  function ShipcoSelectComponent() {
    const { selectProps } = useSelect<IShipco>({
      resource: "shipco",
      optionLabel: "registrationName",
      optionValue: "id",
      filters: query?.data?.data?.shipco?.id
        ? [{ field: "id", operator: "eq", value: query?.data?.data?.shipco?.id }]
        : [],
      pagination: { mode: "server" }
    });
    return (
      <Form.Item
        label="Shipco"
        name={["shipco", "id"]}
        rules={[{ required: true }]}
        initialValue={query?.data?.data?.shipco?.registrationName}
      >
        <Select {...selectProps} disabled />
      </Form.Item>
    );
  }

  function ShipcoGroupSelectComponent() {
    const { selectProps } = useSelect<IShipcoGroup>({
      resource: "shipco-group",
      optionLabel: "registrationName",
      optionValue: "id",
      filters: query?.data?.data?.shipcoGroup?.id
        ? [{ field: "id", operator: "eq", value: query?.data?.data?.shipcoGroup?.id }]
        : [],
      pagination: { mode: "server" }
    });
    return (
      <Form.Item
        label="Shipco Group"
        name={["shipcoGroup", "id"]}
        rules={[{ required: true }]}
        initialValue={query?.data?.data?.shipcoGroup?.registrationName}
      >
        <Select {...selectProps} disabled />
      </Form.Item>
    );
  }

  function VesselSelectComponent() {
    const { selectProps } = useSelect<IVessel>({
      resource: "vessel",
      optionLabel: "name",
      optionValue: "id",
      filters: query?.data?.data?.vessel?.id
        ? [{ field: "id", operator: "eq", value: query?.data?.data?.vessel?.id }]
        : [],
      pagination: { mode: "server" }
    });
    return (
      <Form.Item
        label="Vessel"
        name={["vessel", "id"]}
        rules={[{ required: true }]}
        initialValue={query?.data?.data?.vessel?.name}
      >
        <Select {...selectProps} disabled />
      </Form.Item>
    );
  }

  return (
    <Edit
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "edit contact",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Contact Information"
            subtitle="Personal details"
            icon={<UserOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Contact Name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <FormSection
                title="Contact Details"
                subtitle="Communication information"
                icon={<PhoneOutlined />}
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </FormSection>
            </Col>

            <Col xs={24} lg={12}>
              <FormSection
                title="Associations"
                subtitle="Linked entities"
                icon={<LinkOutlined />}
              >
                {query?.data?.data?.shipco && query?.isSuccess ? <ShipcoSelectComponent /> : null}
                {query?.data?.data?.shipcoGroup && query?.isSuccess ? <ShipcoGroupSelectComponent /> : null}
                {query?.data?.data?.vessel && query?.isSuccess ? <VesselSelectComponent /> : null}
              </FormSection>
            </Col>
          </Row>
        </Space>
      </Form>
    </Edit>
  );
};
